//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const TikTokPopularMusicGenres = {
  All: 'ALL',
  Rock: 'ROCK',
  Pop: 'POP',
  Latin: 'LATIN',
  Metal: 'METAL',
  Electronic: 'ELECTRONIC',
  HipHopRap: 'HIP_HOP/RAP',
  AlternativeIndie: 'ALTERNATIVE/INDIE',
  Folk: 'FOLK',
  RAndBSoul: 'R&B/SOUL',
  Country: 'COUNTRY',
  Classical: 'CLASSICAL',
  Jazz: 'JAZZ',
  Reggae: 'REGGAE',
  Childhood: 'CHILDHOOD',
  Blues: 'BLUES',
  EasyListening: 'EASY_LISTENING',
  NewAge: 'NEW_AGE',
  WorldMusic: 'WORLD_MUSIC',
  Experimental: 'EXPERIMENTAL',
  Devotional: 'DEVOTIONAL',
  ChineseTradition: 'CHINESE_TRADITION',
  EightBit: '8_BIT',
} as const;

// Genre values are provided by TikTok's Business API.
// Reference: https://business-api.tiktok.com/gateway/docs/index?identify_key=c0138ffadd90a955c1f0670a56fe348d1d40680b3c89461e09f78ed26785164b&language=ENGLISH&doc_id=1825119063013505#item-link-List%20of%20values%20for%20genre
// To keep this list up to date, check the "List of values for genre" section
// in the TikTok Business API docs linked above whenever the API is upgraded.
export const TikTokMusicGenre = {
  ...TikTokPopularMusicGenres,
  ACapella: 'A_CAPPELLA',
  AfroPop: 'AFRO-POP',
  AlternativeHipHop: 'ALTERNATIVE_HIP_HOP',
  AlternativeRock: 'ALTERNATIVE_ROCK',
  Ambient: 'AMBIENT',
  ArabicPop: 'ARABIC_POP',
  BassHouse: 'BASS_HOUSE',
  Bgm: 'BGM',
  Boombap: 'BOOMBAP',
  BossaNova: 'BOSSA_NOVA',
  BrazilianFunkStyle: 'BRAZILIAN_FUNK_STYLE',
  BuddhistMusic: 'BUDDHIST_MUSIC',
  Cantopop: 'CANTOPOP',
  CelticPop: 'CELTIC_POP',
  ChamberMusic: 'CHAMBER_MUSIC',
  ChillBeats: 'CHILL_BEATS',
  Chillout: 'CHILLOUT',
  ChineseFolk: 'CHINESE_FOLK',
  ChineseOpera: 'CHINESE_OPERA',
  ChinesePop: 'CHINESE_POP',
  ChineseStyle: 'CHINESE_STYLE',
  ChinoiserieElectronic: 'CHINOISERIE_ELECTRONIC',
  ChinoiserieRap: 'CHINOISERIE_RAP',
  ChristianMusic: 'CHRISTIAN_MUSIC',
  ContemporaryRAndB: 'CONTEMPORARY_R&B',
  CountryPop: 'COUNTRY_POP',
  DancePop: 'DANCE_POP',
  Disco: 'DISCO',
  Dj: 'DJ',
  DrumAndBass: 'DRUM&BASS',
  Dubstep: 'DUBSTEP',
  Edm: 'EDM',
  EdmTrap: 'EDM_TRAP',
  ElectroPop: 'ELECTRO_POP',
  Epic: 'EPIC',
  FolkPop: 'FOLK_POP',
  Funk: 'FUNK',
  FutureBass: 'FUTURE_BASS',
  Gospel: 'GOSPEL',
  GufengMusic: 'GUFENG_MUSIC',
  HardRock: 'HARD_ROCK',
  HipHouse: 'HIP_HOUSE',
  HolidayMusic: 'HOLIDAY_MUSIC',
  House: 'HOUSE',
  IndianPop: 'INDIAN_POP',
  IndieFolk: 'INDIE_FOLK',
  IndiePop: 'INDIE_POP',
  IndieRock: 'INDIE_ROCK',
  InstrumentalHipHop: 'INSTRUMENTAL_HIP_HOP',
  InstrumentalRock: 'INSTRUMENTAL_ROCK',
  IrishFolk: 'IRISH_FOLK',
  JRock: 'J_ROCK',
  JapaneseTraditionalMusic: 'JAPANESE_TRADITIONAL_MUSIC',
  JazzFusion: 'JAZZ_FUSION',
  JazzHipHop: 'JAZZ_HIP_HOP',
  JazzPop: 'JAZZ_POP',
  JPop: 'J-POP',
  KPop: 'K-POP',
  LatinPop: 'LATIN_POP',
  LoFi: 'LO-FI',
  Mc: 'MC',
  Noise: 'NOISE',
  OldSchool: 'OLD_SCHOOL',
  Others: 'OTHERS',
  PopRap: 'POP_RAP',
  PopRock: 'POP_ROCK',
  PopSoul: 'POP_SOUL',
  PsychedelicRock: 'PSYCHEDELIC_ROCK',
  Punk: 'PUNK',
  RAndBRap: 'R&B_RAP',
  Reggaeton: 'REGGAETON',
  RussianPop: 'RUSSIAN_POP',
  Sertanejo: 'SERTANEJO',
  SonCubano: 'SON_CUBANO',
  Soul: 'SOUL',
  Soundtrack: 'SOUNDTRACK',
  Symphony: 'SYMPHONY',
  SynthPop: 'SYNTH_POP',
  Tango: 'TANGO',
  Techno: 'TECHNO',
  TeenPop: 'TEEN_POP',
  TraditionalChineseFolk: 'TRADITIONAL_CHINESE_FOLK',
  Trance: 'TRANCE',
  TrapRap: 'TRAP_RAP',
  TripHop: 'TRIP_HOP',
  TropicalHouse: 'TROPICAL_HOUSE',
  TurkishPop: 'TURKISH_POP',
} as const;

export type TikTokMusicGenre =
  (typeof TikTokMusicGenre)[keyof typeof TikTokMusicGenre];
